import React from 'react';
import Helmet from 'react-helmet';

const Header = () => (
    <Helmet>
        <title>Monest - Cobre suas dívidas e recupere seus clientes.</title>
        <meta property="og:title" content="Monest - Cobre suas dívidas e recupere seus clientes." />
        <meta name="description" content="Monest é a solução para cobrar suas dívidas de forma simples e fácil. O seu dinheiro de volta e o seu cliente também. Saiba mais." />
        <meta property="og:description" content="Monest é a solução para cobrar suas dívidas de forma simples e fácil. O seu dinheiro de volta e o seu cliente também. Saiba mais." />
        <meta property="og:image" content="https://s3.amazonaws.com/monest/static/meta_image_company.png" />

        <meta property="og:type" content="website" />
        <meta property="og:locale" content="pt_BR" />
        <meta property="fb:app_id" content="2004695356493023" />
    </Helmet>
);

export default Header;
